/* @flow */

import * as React from 'react';

import {Body, type BodyProps} from '../typography';
import './error-message.module.css';

type Props = {|
    as: string,
    children: React.Node,
    ...$Exact<BodyProps>,
|};

ErrorMessage.defaultProps = {
    as: 'div',
};

export function ErrorMessage(props: Props) {
    const {as: Tag, children, ...bodyProps} = props;

    return (
        <Tag styleName='error'>
            <Body {...bodyProps}>{children}</Body>
        </Tag>
    );
}
